module.exports = __webpack_public_path__ + "/media/images/use-bg-2-ru.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/use-bg-2-ru.jpg
// module id = 68
// module chunks = 1